<template>
  <div class="w-full">
    <Label v-if="label" :for="id" :required="required">
      {{ label }}
    </Label>
    <div class="flex">
      <div class="relative w-full">
        <div
          v-if="prefixIcon"
          class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
        >
          <component
            :is="prefixIcon"
            class="size-5 text-gray-400"
            aria-hidden="true"
          />
        </div>
        <input
          v-model="value"
          :id="id"
         
          :type="type"
          :name="name"
          class="block w-full border-0 bg-white py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-200 sm:text-sm sm:leading-6"
          :class="{
            'ring-2 ring-inset ring-indigo-600': focused,
            'pl-10': prefixIcon,
            'rounded-md': !button,
            'rounded-l-md': button,
            uppercase: uppercase,
          }"
          :placeholder="placeholder"
          :disabled="disabled"
          :readonly="readOnly"
          :autocomplete="autocomplete"
          :autofocus="autofocus"
          :maxlength="max"
          :max="max"
          @focus="emit('focus', $event)"
          @blur="emit('blur', $event)"
        />
      </div>
      <Button
        v-if="button"
        type="secondary"
        round-type="right"
        class="-ml-px"
        v-bind="buttonProps"
        :disabled="disabled"
        @click="emit('buttonClicked')"
      >
        {{ button }}
      </Button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { Icon } from '@/types';
import Button from '@/components/Button.vue';

type ButtonProps = InstanceType<typeof Button>['$props'];

const props = defineProps({
  modelValue: {
    type: [String, Number],
    required: true,
  },
  label: {
    type: String,
    default: null,
  },
  placeholder: {
    type: String,
    default: null,
  },
  type: {
    type: String,
    default: 'text',
  },
  name: {
    type: String,
    default: null,
  },
  id: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  focused: {
    type: Boolean,
    default: false,
  },
  readOnly: {
    type: Boolean,
    default: false,
  },
  prefixIcon: {
    type: Function as PropType<Icon>,
    default: null,
  },
  button: {
    type: String,
    default: null,
  },
  buttonProps: {
    type: Object as PropType<ButtonProps>,
    default: undefined,
  },
  autocomplete: {
    type: String,
  },
  autofocus: {
    type: Boolean,
  },
  max: {
    type: Number,
  },
  uppercase: {
    type: Boolean,
  },
  required: {
    type: Boolean,
  },
  dataTestid: {
    type: String,
    default: null,
  },
});

const emit = defineEmits([
  'update:modelValue',
  'focus',
  'blur',
  'buttonClicked',
]);

const value = computed({
  get: () => props.modelValue,
  set: (value) => {
    if (!props.readOnly) {
      emit('update:modelValue', value);
    }
  },
});
</script>
